import { Message } from 'element-ui';

const MessagePlugin = {
    install(Vue) {
         // 配置默认选项
         const defaultOptions = {
            duration: 1500,
            center: true
        };
        
        // 创建新的消息实例方法
        const message = (options) => {
            return Message({
                ...defaultOptions,
                ...options
            });
        };
        
        // 添加类型方法
        ['success', 'warning', 'info', 'error'].forEach(type => {
            message[type] = (options) => {
                if (typeof options === 'string') {
                    options = {
                        message: options
                    };
                }
                return Message({
                    ...defaultOptions,
                    ...options,
                    type
                });
            };
        });

        Vue.prototype.$message = message;
        window.$message = message;
    }
};

export const showError = (message) => {
    if (window.$message) {
        window.$message.error({
            message: message,
            center: true,
            duration: 1000  
        });
    } else {
        console.error('Message plugin not found:', message);
    }
};

export const showSuccess = (message) => {
    if (window.$message) {
        window.$message.success({
            message: message,
            center: true,
            duration: 1000
        });
    }
};

export const showWarning = (message) => {
    if (window.$message) {
        window.$message.warning({
            message: message,
            center: true,
            duration: 1000
        });
    }
};

export const showInfo = (message) => {
    if (window.$message) {
        window.$message.info({
            message: message,
            center: true,
            duration: 1000
        });
    }
};

export default MessagePlugin;